export function getFirebaseImageUrl(imageId: string) {
    if (window.location.hostname === 'app.bilgo.se') {
        return `https://firebasestorage.googleapis.com/v0/b/bilgo-prod.appspot.com/o/${imageId}?alt=media`
    }
    return `https://firebasestorage.googleapis.com/v0/b/bilsmart.appspot.com/o/${imageId}?alt=media`
}